const { version }: { version: string } = require('../../package.json');

export const environment = {
  production: false,
  baseUrl: 'https://api-install-desa.sodimac-it.com/api/',
  baseUrl2: 'https://apibeta.cloud.sodimac-it.com/sodimac/api/',
  keycloakUrl: 'https://qa-access-key-corp.falabella.tech/auth/',
  keyckoakRealm: 'corp',
  appVersion: version,
  googleApiKey: '',
  authGenerateToken: 'pgs-authentication/authentication/generate',
  authRefreshToken: 'pgs-authentication/authentication/refresh-token',
  location_locations: 'pgs-vendor-front/localization/country/',
  vendors_vendor: 'pgs-vendor-front/vendor',
  vendors_contacTypes: 'pgs-vendor-front/contactType',
  vendors_updateVendor: 'pgs-vendor-front/vendor',
  vendors_persons: 'pgs-vendor-front/vendor/partialSearch',
  vendorsPayment_documentTypes: 'pgs-tributarydoc-front/documentType',
  vendorsPayment_vendorDocument: 'pgs-tributarydoc-front/tributaryDocument',
  vendorsPayment_annulmentCauses: 'pgs-tributarydoc-front/reason',
  vendorsPayment_order: 'pgs-order-front/order',
  vendorsPayment_transferTypes: 'pgs-tributarydoc-front/transferType',
  vendorsPayment_submitTransfer: 'pgs-tributarydoc-front/soclapse/generateSoclapse',
  vendorsPayment_addOrder: 'pgs-tributarydoc-front/addOrderToDocument',
  vendorsPayment_removeOrder: 'pgs-tributarydoc-front/removeOrderToDocument',
  vendorsPayment_addDocument: 'pgs-tributarydoc-front/tributaryDocument/addAssociatedDocument',
  vendorsPayment_removeDocument: 'pgs-tributarydoc-front/tributaryDocument/removeAssociatedDocument',
  vendorsPayment_toleranceAmount: 'pgs-tributarydoc-front/tributaryDocument/adjustmentToleranceAmount',
  vendorsPayment_massiveConciliation: 'pgs-tributarydoc-front/tributaryDocument/generateMassiveConciliation',
  vendorsPayment_transferConciliated: 'pgs-tributarydoc-front/soclapse/generateSoclapseConciliatedTransfer',
  vendorsPayment_addTaxDistribution: 'pgs-tributarydoc-front/costCenter/addTaxDistribution',
  reports_order_order_report: 'pgs-order-front/order/getForOrderReport',
  reports_order_by_email: 'pgs-order-front/order/getConsultByOrder',
  reports_retireTypes: 'pgs-vendor-front/getRetireTypes',
  reports_retirementWarrantyFund: 'pgs-vendor-front/retirementWarrantyFund',
  reports_auxiliaryWarranty: 'pgs-vendor-front/warrantyFundAuxiliar',
  reports_auxiliaryWarrantyByEmail: 'pgs-vendor-front/warrantyFundAuxiliar/report',
  vendorsPayment_documentStatus_documentStatus: 'pgs-tributarydoc-front/beenSent/getAllStatus',
  vendorsPayment_documentStatus_guid: 'pgs-tributarydoc-front/beenSent/guid',
  vendorsPayment_documentStatus_documentInterfaces: 'pgs-tributarydoc-front/beenSent/getAllInterface',
  vendorsPayment_documentStatus_documents: 'pgs-tributarydoc-front/soclapse/beenSent',
  vendorsPayment_documentStatus_documents_LC: 'pgs-tributarydoc-front/soclapse/beenSentLCDetail',
  vendorsPayment_documentStatus_documents_LP: 'pgs-tributarydoc-front/soclapse/beenSentLPDetail',
  vendorsPayment_documentStatus_documents_CR: 'pgs-tributarydoc-front/soclapse/beenSentCRDetail',
  vendorsPayment_errorsCorrection_actionType: 'pgs-tributarydoc-front/actionType',
  vendorsPayment_errorsCorrection_correctionError: 'pgs-tributarydoc-front/soclapse/correctionErrorGet',
  vendorsPayment_errorsCorrection_correctionAction: 'pgs-tributarydoc-front/soclapse/correctionErrorAction',
  vendorsPayment_sendCR: 'pgs-tributarydoc-front/sap/oc',
  vendorsPayment_loadDocuments: 'pgs-tributarydoc-front/tributaryDocument/insertMassiveBill',
  reports_documentReceptionReport: 'pgs-tributarydoc-front/tributaryDocument/documentReceptionReport',
  reports_documentReceptionByEmail: 'pgs-tributarydoc-front/tributaryDocument/documentReceptionLarge',
  reports_massiveDocumentsStatus_dateTypes: 'pgs-tributarydoc-front/dateTypes',
  reports_massiveDocumentsStatus_documentsStatus: 'pgs-tributarydoc-front/statusTypes',
  reports_massiveDocumentsStatus: 'pgs-tributarydoc-front/massiveExtraction',
  reports_massiveDocumentsByEmail: 'pgs-tributarydoc-front/massiveExtractionAsync',
  reports_postpayCreditNote: 'pgs-tributarydoc-front/tributaryDocument/creditNoteReport',
  set_user: 'pgs-utils-public-front/user',
  get_user: 'pgs-utils-public-front/user/getUser/',
  proyect_payment_proyect: 'pgs-order-front/leadOrder/',
  sales_client_clientTypes: 'pgs-customer-front/customerType',
  sales_client_client: 'pgs-customer-front/customer',
  sales_service_manager_questions: 'pgs-services-manager-front/servicesManager/getNodeQuestions',
  sales_service_manager_feasibility: 'pgs-services-manager-front/servicesManager/coverage',
  sales_service_manager_serviceNodeList: 'pgs-services-manager-front/servicesManager/ServiceNodeLevelList/',
  sales_service_manager_getServicesListByTenant: 'pgs-services-manager-front/servicesManager/getServicesListByTenant',
  sales_service_manager_serviceNode: 'pgs-services-manager-front/servicesManager',
  sales_project: 'pgs-order-front/parentOrder',
  sales_project_add_sku: 'pgs-order-front/parentOrder/childOrder/addSkuToChildOrder',
  sales_project_remove_sku: 'pgs-order-front/parentOrder/childOrder/removeSkuToChildOrder',
  sales_project_add_service: 'pgs-order-front/parentOrder/childOrder/create',
  sales_project_remove_service: 'pgs-order-front/childOrder',
  sales_contract_generate_contract_pdf_html: 'pgs-services-manager-front/service/generateContractPdfHTML',
  sales_contract_send_mail_contract_pdf: 'pgs-services-manager-front/service/sendMailContractPdf',
  sales_contract_generate_contract_pdf: 'pgs-services-manager-front/service/generateContractPdf',
  sales_contract_generate_contract_pdf_code_64: 'pgs-services-manager-front/service/generateContractPdfCode64',
  sales_contract_finish: 'pgs-services-manager-front/service/finishContracts',
  sales_fsa: 'pgs-services-manager-front/fsa',
  projects_search_by_customer: 'pgs-order-front/projectOrder/',
  projects_search_by_id: 'pgs-order-front/projectDetailedOrder/',
  projects_search_by_id_for_sale: 'pgs-order-front/leadParent/{leadParentId}/sale',
  projects_search_by_leadid: 'pgs-order-front/projectDetailedOrderChild/',
  projects_tracking: 'pgs-order-front/parentOrder/trackingPanel',
  projects_tracking_status: 'pgs-order-front/projectStatus/all',
  projects_binnacle: 'pgs-order-front/binnacle',
  products_search_name: 'pgs-order-front/product/searchName',
  products_search_sku: 'pgs-order-front/product/searchSku',
  users_roles: 'pgs-utils-public-front/role/getAllRoles',
  user_mail_search: 'pgs-utils-public-front/user/getUserForModification',
  stores_stores: 'pgs-utils-public-front/user/getStore/',
  stores_brand: 'pgs-services-manager-front/brand/',
  products_home_delivery: 'pgs-order-front/dadIntegration/deliveryService',
  products_store_delivery: 'pgs-order-front/dadIntegration/storeWithdrawal',
  products_create_reservation: 'pgs-order-front/dadIntegration/reservationCreate/',
  products_cancel_reservation: 'pgs-order-front/dadIntegration/reservationCancel/',
  projects_sale_order: 'pgs-order-front/saleOrder',
  reactive_projects: 'pgs-order-front/parentOrder/reactive',
  order_health: 'pgs-order-front/health',
  order_version: 'pgs-order-front/info',
  service_manager_health: 'pgs-services-manager-front/health',
  service_manager_version: 'pgs-services-manager-front/info',
  product_health: 'pgs-product-front/health',
  product_version: 'pgs-product-front/info',
  customer_health: 'pgs-customer-front/health',
  customer_version: 'pgs-customer-front/info',
  utils_public_health: 'pgs-utils-public-front/health',
  utils_public_version: 'pgs-utils-public-front/info',
  utils_private_health: 'pgs-utils-front/health',
  tributarydoc_health: 'pgs-tributarydoc-front/health',
  tributarydoc_version: 'pgs-tributarydoc-front/info',
  vendor_health: 'pgs-vendor-front/health',
  vendor_version: 'pgs-vendor-front/info',
  insert_orders: 'pgs-order-front/order/ssee/migrateOrders',
  master_data: 'pgs-services-manager-front/Category/updateFromExternal/',
  get_retention: 'pgs-tributarydoc-front/retention/getAllRetention',
  retention: 'pgs-tributarydoc-front/retention',
  channel_services: 'pgs-channel-front/service/generic/sku',
  channel_error_all: 'pgs-channel-front/channel/error/all',
  channel_error: 'pgs-channel-front/channel/error',
  channel_straggler: 'pgs-channel-front/channel/straggler',
  channel_validate_sku_service: 'pgs-channel-front/servicegenericsku/hermes',
  massive_load_export: 'pgs-vendor-front/massiveLoad/export',
  massive_load_import: 'pgs-vendor-front/vendor/importMasiveLoad',
  search_lead_by_filter: 'pgs-order-front/search/leadOrdersByFilter',
  excelLeadOrdersByFilter: 'pgs-order-front/export/excelLeadOrdersByFilter',
  checkoutManualPayment: 'pgs-order-front/manualPayment',
  customerBucError: 'pgs-customer-front/customer/error/suscription',
  sodtrackProyUrl: 'https://admin.cl.sodimac.sodtrack.com/es/dashboard/project/',
  findAllServicesUpdate: '/findAllExecutions',
  configExecutionLoadConfig: 'bff-auto-configuration-process/v1.0/configExecution/processFileConfig',
  configExecutionStopExecution: 'bff-auto-configuration-process/v1.0/configExecution/updateProcessExecution',
  configExecutionLoadFlow: 'bff-auto-configuration-process/v1.0/configExecution/loadflow',
  configExecutionPriorities: 'bff-auto-configuration-process/v1.0/configExecution/priorities',
  configExecutionFindAllExecutions: 'bff-auto-configuration-process/v1.0/configExecution/findAllExecutions',
  configExecutionDownloadFile: 'bff-auto-configuration-process/v1.0/configExecution/file',
};



export const authConfig: any = {
  logoutTimeoutMinutes: 30,
  authority: 'https://login.microsoftonline.com/common',
  redirectUri: window.location.origin,
  // clientId: 'f72b92a6-443d-4825-a6cd-a24729c00876',
  clientId: '40d27c6e-cebd-4cdc-9120-61272ee37d9b',
  scope: 'openid profile email https://buffet-guests-list.azurewebsites.net/read',
  buffetUrl: 'https://buffet-guests-list.azurewebsites.net/api/gateway-jwt',
  buffetCode: 'cLyTq96aAj6DvpPbFWhsCqlP/GgAQZhzoNE0YD1Rw70Bx2Ma5P3CRg==',
  postLogoutRedirectUri: window.location.origin + '/',
  logoutUrl: 'https://login.microsoftonline.com/c4a8886b-f140-478b-ac47-249555c30afd/oauth2/logout',
};
